import React from "react";
import { Clock, XCircle } from "lucide-react";

export function AiNotesPanel({ video }) {
  if (video.transcript_status === "processing") {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-400" data-testid="ai-notes-processing">
        <Clock className="w-4 h-4 text-amber-400 animate-pulse" /> AI is generating notes from this video's audio — check back in a bit.
      </div>
    );
  }
  if (video.transcript_status === "failed") {
    return (
      <div className="flex items-center gap-2 text-sm text-rose-400" data-testid="ai-notes-failed">
        <XCircle className="w-4 h-4" /> {video.error_message || "Couldn't generate AI notes for this video."}
      </div>
    );
  }
  if (!video.ai_notes) {
    return <p className="text-sm text-slate-500" data-testid="ai-notes-empty">No AI notes available.</p>;
  }
  return (
    <div className="space-y-4" data-testid="ai-notes-content">
      <div>
        <h4 className="text-xs font-bold uppercase tracking-wider text-amber-300 mb-1.5">Summary</h4>
        <p className="text-sm text-slate-300 leading-relaxed">{video.ai_notes.summary}</p>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-wider text-amber-300 mb-1.5">Key Points</h4>
        <ul className="space-y-1.5">
          {video.ai_notes.key_points.map((p, i) => (
            <li key={i} className="text-sm text-slate-300 flex gap-2"><span className="text-amber-400">•</span> {p}</li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-wider text-amber-300 mb-1.5">Topics Covered</h4>
        <div className="flex flex-wrap gap-1.5">
          {video.ai_notes.topics_covered.map((t, i) => (
            <span key={i} className="text-xs font-medium bg-white/5 border border-white/10 text-slate-300 px-2.5 py-1 rounded-full">{t}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
